import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    watchIsActive: false,
    readIsActive: false,
    learnIsActive: false,
    favouritesIsActive: false,
    readOffCanvasIsActive: false,
    learnOffCanvasIsActive: false,
    watchOffCanvasIsActive: false,
    videoModalIsActive: false,
    faveOffCanvasToggled: false,
    faveWatchOffCanvasIsActive: false,
    faveReadOffCanvasIsActive: false,
    faveLearnOffCanvasIsActive: false
}


export const navBarSlice = createSlice({
    name: "navBar", //?
    initialState,
    reducers:{
        navBarReset: (state) => initialState,
        setLandingIsActive: (state) =>{
            state.landingIsActive = true;
            state.watchIsActive = false;
            state.readIsActive = false;
            state.learnIsActive = false;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = false;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setWatchIsActive: (state) =>{
            state.landingIsActive = false;
            state.watchIsActive = true;
            state.readIsActive = false;
            state.learnIsActive = false;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = false;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setReadIsActive: (state) =>{
            state.landingIsActive = false;
            state.watchIsActive = false;
            state.readIsActive = true;
            state.learnIsActive = false;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = false;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setLearnIsActive: (state) =>{
            state.landingIsActive = false;
            state.watchIsActive = false;
            state.readIsActive = false;
            state.learnIsActive = true;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = false;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setFavouritesIsActive: (state) =>{
            state.landingIsActive = false;
            state.watchIsActive = false;
            state.readIsActive = false;
            state.learnIsActive = false;
            state.favouritesIsActive = true;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = false;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setReadOffCanvasIsActive: (state) =>{
            state.landingIsActive = false;
            state.watchIsActive = false;
            state.readIsActive = true;
            state.learnIsActive = false;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = true;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = false;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setLearnOffCanvasIsActive: (state) =>{
            state.landingIsActive = false;
            state.watchIsActive = false;
            state.readIsActive = false;
            state.learnIsActive = true;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = true;
            state.watchOffCanvasIsActive = false;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setWatchOffCanvasIsActive: (state) =>{
            state.landingIsActive = false;
            state.watchIsActive = true;
            state.readIsActive = false;
            state.learnIsActive = false;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = true;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },
        setVideoModalIsActive: (state) => {
            state.landingIsActive = false;

            state.watchIsActive = true;
            state.readIsActive = false;
            state.learnIsActive = false;
            state.favouritesIsActive = false;
            state.readOffCanvasIsActive = false;
            state.learnOffCanvasIsActive = false;
            state.watchOffCanvasIsActive = true;
            state.videoModalIsActive = true;

            state.faveOffCanvasToggled = false;
            state.faveWatchOffCanvasIsActive = false;
            state.faveReadOffCanvasIsActive = false;
            state.faveLearnOffCanvasIsActive = false;
        },

        toggleFaveWatchOffCanvasIsActive: (state) => {
            state.faveOffCanvasToggled = !state.faveOffCanvasToggled;
            state.faveWatchOffCanvasIsActive = !state.faveWatchOffCanvasIsActive;
        },
        toggleFaveReadOffCanvasIsActive: (state) =>{
            state.faveOffCanvasToggled = !state.faveOffCanvasToggled;
            state.faveReadOffCanvasIsActive = !state.faveReadOffCanvasIsActive;
        },
        toggleFaveLearnOffCanvasIsActive: (state) =>{
            state.faveOffCanvasToggled = !state.faveOffCanvasToggled;
            state.faveLearnOffCanvasIsActive = !state.faveLearnOffCanvasIsActive;
        },



    },
})



export const {
    navBarReset,
    setWatchIsActive,
    setReadIsActive,
    setLearnIsActive,
    setFavouritesIsActive,
    setReadOffCanvasIsActive,
    setLearnOffCanvasIsActive,
    setWatchOffCanvasIsActive,
    setVideoModalIsActive,
    setLandingIsActive,
    toggleFaveWatchOffCanvasIsActive,
    toggleFaveReadOffCanvasIsActive,
    toggleFaveLearnOffCanvasIsActive,
} = navBarSlice.actions;

export default navBarSlice.reducer;